import React, { FC } from 'react'
import { Button, Stack } from '@mui/material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { RADIUS } from '@/shared/styles/radii'

// Notion 流 inline tab. metrics/usage 等の mode 切替 ad-hoc Stack-of-Button を統一.
// active = 13/600 + overlay.selected, inactive = 13/500 transparent, hover で bg 軽く.
interface TabRowProps<T extends string = string> {
  tabs: { id: T; label: string }[]
  active: T
  onChange: (id: T) => void
}

export const TabRow = <T extends string = string>({
  tabs,
  active,
  onChange,
}: TabRowProps<T>): ReturnType<FC> => (
  <Stack direction="row" gap={0.5}>
    {tabs.map((t) => (
      <Button
        key={t.id}
        size="small"
        onClick={() => onChange(t.id)}
        sx={{
          fontSize: 13,
          fontWeight: active === t.id ? 600 : 500,
          color: active === t.id ? 'text.primary' : 'text.secondary',
          bgcolor:
            active === t.id ? colorTokens.overlay.selected : 'transparent',
          borderRadius: `${RADIUS.md}px`,
          px: 1.25,
          py: 0.5,
          minWidth: 'auto',
          textTransform: 'none',
          '&:hover': {
            bgcolor: colorTokens.overlay.selected,
          },
        }}
      >
        {t.label}
      </Button>
    ))}
  </Stack>
)
